import { useAppSelector } from '@/hooks/use.redux';

export function useCookies() {
  const cookies = useAppSelector((state) => state.userReducer.cookies);
  return cookies;
}
